export enum OrderType {
  Sale = 'Sale',
  Purchase = 'Purchase',

  /***
   * Only for frontend using. Do not send on backend. And do not show in select.
   */
  All = 'All',
}
